import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import AdvanceBillReportsContent from './AdvanceBillReportsContent';
import { fetchAdvanceBillsData } from './advanceBillReportsSlice';

const AdvanceBillReportsAdmin = () => {
    const dispatch = useDispatch();
    const storedBranchId = localStorage.getItem('branchid') || '';

    useEffect(() => {
        const toDate = new Date();
        const fromDate = new Date();
        fromDate.setDate(fromDate.getDate() - 30);

        dispatch(
            fetchAdvanceBillsData({
                fromDate,
                toDate,
                branchId: storedBranchId,
                status: ''
            })
        );
    }, [dispatch, storedBranchId]);

    return <AdvanceBillReportsContent />;
};

export default AdvanceBillReportsAdmin;
